import { render, staticRenderFns } from "./simple_pagination.vue?vue&type=template&id=3233fcd3&"
import script from "./simple_pagination.vue?vue&type=script&lang=ts&"
export * from "./simple_pagination.vue?vue&type=script&lang=ts&"
import style0 from "./simple_pagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports